
import { mapActions, mapGetters } from "vuex";
import {
  MENU_ITEM_AVAILABILITY_UPDATED,
  MENU_PUBLISHED
} from "@/constants/MixpanelEvents.js";
export default {
  props: {
    classProp: {
      type: String,
      default: "menu-update-button-mobile"
    },
    colorProp: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("menu", [
      "getEnableDisableItems",
      "isCatalogueSyncPending",
      "isAvailabilitySyncPending",
      "syncPendingTotalCount"
    ]),
    ...mapGetters("restaurant", ["getMenuUpdateDisabledObj"]),

    isDisabled() {
      return !(
        this.isAvailabilitySyncPending ||
        (this.getMenuUpdateDisabledObj ? false : this.isCatalogueSyncPending)
      );
    }
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getAddons",
      "availabilitySync",
      "catalogueSync",
      "getSyncStatus",
      "getCombosList"
    ]),
    async handleSync() {
      this.loading = true;
      try {
        if (this.isCatalogueSyncPending && !this.getMenuUpdateDisabledObj) {
          await this.handleCatalogueSync();
        }
        if (this.isAvailabilitySyncPending) await this.handleAvailabilitySync();
        await this.sleep(2000);
        await this.getSyncStatus();
        await Promise.all([
          this.getMenuList(true),
          this.getAddons(true),
          this.getCombosList(true)
        ]);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.loading = false;
    },
    async handleAvailabilitySync() {
      let { enable, disable } = this.getEnableDisableItems;

      try {
        await this.availabilitySync({ enable, disable });
        this.mixPanelTrackEvent(MENU_ITEM_AVAILABILITY_UPDATED);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    },
    async handleCatalogueSync() {
      try {
        await this.catalogueSync();
        this.mixPanelTrackEvent(MENU_PUBLISHED);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    }
  }
};
